/* used for both AMC and Hospital reserach type sites:
- Academic Medical Center or Clinical Trials Unit
- Hospital or Health System
*/

import { TextField, Grid, useTheme, useMediaQuery } from '@mui/material';
import { getControlId } from '@veeva-ctv/utils';
import { FormikProps } from 'formik';
import { SiteApplicationInput } from '@/gql/graphql';
import StandardCountryStateProvinceInput from '@/components/StandardCountryStateProvinceInput';
import { UIOnlyFields } from '@/types';

interface AMCFormProps {
  formik: FormikProps<UIOnlyFields & SiteApplicationInput>;
}

const AMCHospitalForm = ({ formik }: AMCFormProps) => {
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Grid item xs={12}>
        <TextField
          id={getControlId({ type: 'text', name: 'organizationName' })}
          name="organization"
          label="Institution name*"
          fullWidth
          inputProps={{ autoComplete: 'one-time-code' }}
          value={formik.values.organization}
          error={formik.touched.organization && Boolean(formik.errors.organization)}
          helperText={formik.touched.organization && formik.errors.organization}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          id={getControlId({ type: 'text', name: 'name' })}
          name="name"
          label="What is your specific department, location, or division of research called?*"
          placeholder="Provide the full unabbreviated name. This is required to create your account."
          fullWidth
          inputProps={{ autoComplete: 'one-time-code' }}
          value={formik.values.name}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          //fix for long labels to wrap around nicely on mobile and not overlap with the input
          InputLabelProps={{
            sx: { whiteSpace: smDown ? 'normal' : 'wrap', top: smDown ? '-28px' : '-14px' },
          }}
          sx={{ marginTop: smDown ? '32px' : '20px' }}
        />
      </Grid>

      <StandardCountryStateProvinceInput
        formik={formik}
        addressFieldName="address1"
        stateFieldName="stateProvince"
        countryFieldName="country"
        cityFieldName="city"
        postalCodeFieldName="postalCode"
      />

      <Grid item xs={12}>
        <TextField
          id={getControlId({ type: 'text', name: 'url' })}
          name="url"
          label="Website*"
          fullWidth
          inputProps={{ autoComplete: 'one-time-code' }}
          value={formik.values.url}
          error={formik.touched.url && Boolean(formik.errors.url)}
          helperText={formik.touched.url && formik.errors.url}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </Grid>
    </>
  );
};

export default AMCHospitalForm;
